import { c as _c } from "react/compiler-runtime";
import { TextLink } from './textLink';
interface ReadMoreLinkProps {
  text?: string;
  href: string;
  className?: string;
}
export const ReadMoreLink = t0 => {
  const $ = _c(4);
  const {
    text,
    href,
    className
  } = t0;
  const textWithArrow = `${text || "Learn more"} →`;
  let t1;
  if ($[0] !== className || $[1] !== href || $[2] !== textWithArrow) {
    t1 = <TextLink href={href} target="_blank" className={className}>{textWithArrow}</TextLink>;
    $[0] = className;
    $[1] = href;
    $[2] = textWithArrow;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};